import React from 'react';

const ReformGuideHeader = () => (
  <div>
    <h2>The Most Freelance-Savvy States in the USA</h2>
  </div>
);

export default ReformGuideHeader;



// WEBPACK FOOTER //
// ./src-react/UsaMap/headers/ReformGuideHeader.jsx